module.exports = __webpack_public_path__ + "fixado.png?58bda23b53296a9ff06c3fd4b03bcec6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fixado.png
// module id = 1310
// module chunks = 0